
const inView=el=>{const r=el.getBoundingClientRect();return r.top<innerHeight*0.92&&r.bottom>0;};
function count(el){const raw=el.dataset.count,m=raw.match(/[0-9.]+/);
 if(!m||typeof requestAnimationFrame!=='function'){el.textContent=raw;return;}
 const target=parseFloat(m[0]),dec=(m[0].split('.')[1]||'').length;let t0=null;
 const step=ts=>{t0=t0||ts;const p=Math.min((ts-t0)/850,1),e=1-Math.pow(1-p,3);
  el.textContent=raw.replace(m[0],(target*e).toFixed(dec));
  if(p<1)requestAnimationFrame(step);else el.textContent=raw;};requestAnimationFrame(step);}
const cio=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){count(x.target);cio.unobserve(x.target)}}),{threshold:.35});
const bio=new IntersectionObserver(es=>es.forEach(x=>{if(x.isIntersecting){x.target.style.width=x.target.dataset.w+'%';bio.unobserve(x.target)}}),{threshold:.3});
function arm(root){root=root||document;
 root.querySelectorAll('[data-count]').forEach(el=>{if(el.dataset.done)return;el.dataset.done=1;
  if(inView(el)){count(el);}else{el.textContent=el.dataset.count.replace(/[0-9.]+/,'0');cio.observe(el);}});
 root.querySelectorAll('.bf').forEach(el=>{if(inView(el))el.style.width=el.dataset.w+'%';else bio.observe(el);});}
arm();
setTimeout(()=>{document.querySelectorAll('[data-count]').forEach(el=>{
 if(el.textContent!==el.dataset.count)el.textContent=el.dataset.count;});
 document.querySelectorAll('.bf').forEach(el=>{if(!el.style.width)el.style.width=el.dataset.w+'%';});},2600);

/* ── per-tab subject-matter backgrounds, drawn live ──────────────────────
   thesis = market curves · team = drifting light · technology = data network
   investors = a returns field · contact = an outgoing signal.
   Static first frame is drawn even when motion is reduced or rAF is absent. */
function initBG(cv){
 if(cv.dataset.on)return; cv.dataset.on=1;
 const kind=cv.dataset.bg, ctx=cv.getContext('2d');
 const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
 let W=0,H=0,t=0;
 const fit=()=>{const r=cv.getBoundingClientRect();
  const d=Math.min(devicePixelRatio||1,2);
  W=Math.max(1,Math.round(r.width));H=Math.max(1,Math.round(r.height));
  cv.width=W*d;cv.height=H*d;ctx.setTransform(d,0,0,d,0,0);};
 fit(); addEventListener('resize',fit);
 const rnd=(n,s)=>{let x=Math.sin(n*127.1+s*311.7)*43758.5453;return x-Math.floor(x);};
 // one-time layouts
 const nodes=[...Array(30)].map((_,i)=>({x:rnd(i,1),y:rnd(i,2),p:rnd(i,3)*6.28}));
 const bars=[...Array(46)].map((_,i)=>({h:.25+rnd(i,7)*.65,s:rnd(i,8)*6.28}));
 const orbs=[...Array(7)].map((_,i)=>({x:rnd(i,4),y:rnd(i,5),r:.18+rnd(i,6)*.3,s:rnd(i,9)*6.28}));
 function draw(){
  ctx.clearRect(0,0,W,H);
  const g=ctx.createLinearGradient(0,0,W,H);
  g.addColorStop(0,'#0a1729');g.addColorStop(1,'#0e2440');
  ctx.fillStyle=g;ctx.fillRect(0,0,W,H);
  if(kind==='thesis'){                       // rising market curves
   for(let s=0;s<4;s++){
    ctx.beginPath();
    for(let x=0;x<=W;x+=8){
     const n=x/W;
     const y=H*(.78-s*.11)-Math.sin(n*3.1+t*.0006+s)*22-n*H*.22
             -Math.sin(n*9+t*.0011+s*2)*7;
     x?ctx.lineTo(x,y):ctx.moveTo(x,y);}
    ctx.strokeStyle=s===0?'rgba(195,154,77,.55)':`rgba(120,170,205,${.26-s*.05})`;
    ctx.lineWidth=s===0?2:1.2;ctx.stroke();}
  }else if(kind==='technology'){             // node network + travelling pulses
   for(let i=0;i<nodes.length;i++)for(let j=i+1;j<nodes.length;j++){
    const a=nodes[i],b=nodes[j];
    const dx=(a.x-b.x),dy=(a.y-b.y),d=Math.hypot(dx,dy);
    if(d<.235){ctx.beginPath();ctx.moveTo(a.x*W,a.y*H);ctx.lineTo(b.x*W,b.y*H);
     ctx.strokeStyle=`rgba(110,175,215,${(.235-d)*1.5})`;ctx.lineWidth=1;ctx.stroke();
     const k=(t*.00035+ (i+j)*.13)%1;
     ctx.beginPath();ctx.arc(a.x*W+(b.x-a.x)*W*k,a.y*H+(b.y-a.y)*H*k,1.8,0,6.29);
     ctx.fillStyle='rgba(210,235,250,.75)';ctx.fill();}}
   nodes.forEach((n,i)=>{const pl=1.7+Math.sin(t*.0016+n.p)*.7;
    ctx.beginPath();ctx.arc(n.x*W,n.y*H,pl+1,0,6.29);
    ctx.fillStyle='rgba(195,154,77,.75)';ctx.fill();});
  }else if(kind==='investors'){              // a field of returns
   const bw=W/bars.length;
   bars.forEach((b,i)=>{const h=H*b.h*(.62+Math.sin(t*.0009+b.s)*.16);
    const gg=ctx.createLinearGradient(0,H-h,0,H);
    gg.addColorStop(0,'rgba(195,154,77,.42)');gg.addColorStop(1,'rgba(195,154,77,0)');
    ctx.fillStyle=gg;ctx.fillRect(i*bw+bw*.22,H-h,bw*.56,h);});
  }else if(kind==='contact'){                // an outgoing signal
   for(let r=0;r<5;r++){
    const k=((t*.00022)+r*.2)%1, rad=k*Math.max(W,H)*.72;
    ctx.beginPath();ctx.arc(W*.5,H*.62,rad,0,6.29);
    ctx.strokeStyle=`rgba(150,200,230,${(1-k)*.30})`;ctx.lineWidth=1.4;ctx.stroke();}
  }else{                                     // team — drifting light
   orbs.forEach(o=>{const x=(o.x+Math.sin(t*.00013+o.s)*.11)*W,
    y=(o.y+Math.cos(t*.00016+o.s)*.09)*H, rad=o.r*Math.max(W,H)*.55;
    const rg=ctx.createRadialGradient(x,y,0,x,y,rad);
    rg.addColorStop(0,'rgba(150,185,215,.15)');rg.addColorStop(1,'rgba(150,185,215,0)');
    ctx.fillStyle=rg;ctx.beginPath();ctx.arc(x,y,rad,0,6.29);ctx.fill();});}
 }
 draw();
 if(!reduce&&typeof requestAnimationFrame==='function'){
  const loop=ts=>{t=ts;draw();requestAnimationFrame(loop);};requestAnimationFrame(loop);}
}
function armBG(root){(root||document).querySelectorAll('canvas.bgc').forEach(initBG);}
armBG();

// scroll position works whether the page or an inner element is the scroller
const sy=()=>window.scrollY||document.scrollingElement?.scrollTop||document.documentElement.scrollTop||0;
const onScroll=()=>{const h=document.querySelector('header');if(h)h.classList.toggle('small',sy()>80);
 const b=document.querySelector('.toTop');if(b)b.classList.toggle('on',sy()>500);};
addEventListener('scroll',onScroll,{passive:true});
document.addEventListener('scroll',onScroll,{passive:true,capture:true});
onScroll();
// back-to-top: a real listener, not an inline handler (inline ones are CSP-blocked)
function toTopNow(){
 // Try smooth on every plausible scroller, then GUARANTEE arrival. Smooth
 // scrolling is silently ignored in some embeds, which left the arrow doing
 // nothing at all.
 const els=[document.scrollingElement,document.documentElement,document.body];
 els.forEach(e=>{if(e&&e.scrollTo){try{e.scrollTo({top:0,behavior:'smooth'});}catch(_){}}});
 try{window.scrollTo({top:0,behavior:'smooth'});}catch(_){}
 setTimeout(()=>{els.forEach(e=>{if(e&&e.scrollTop)try{e.scrollTop=0;}catch(_){}});
  try{if(window.scrollY)window.scrollTo(0,0);}catch(_){}},480);}
const topBtn=document.querySelector('.toTop');
if(topBtn)topBtn.addEventListener('click',toTopNow);
// Mail CTAs: still real mailto links, but always give visible feedback and copy the
// address — inside an embedded preview the mail client may never open.
function toast(msg){let t=document.querySelector('.toastbar');
 if(!t){t=document.createElement('div');t.className='toastbar';document.body.appendChild(t);}
 t.textContent=msg;t.classList.add('on');clearTimeout(t._h);t._h=setTimeout(()=>t.classList.remove('on'),3400);}
document.addEventListener('click',e=>{const a=e.target.closest('a[href^="mailto:"]');
 if(!a)return;const addr=decodeURIComponent(a.getAttribute('href').slice(7).split('?')[0]);
 if(navigator.clipboard)navigator.clipboard.writeText(addr).catch(()=>{});
 toast('Email address copied — '+addr);});
// button-level flourish only — no screen takeover
function surf(then){const b=document.querySelector('#surfcta');
 if(b){b.classList.add('ride');setTimeout(()=>b.classList.remove('ride'),700);}
 setTimeout(()=>{then&&then();},260);}

// ── modal forms ────────────────────────────────────────────────────────
// Submissions POST to the firm's own endpoint rather than a Shopify contact
// form, because Shopify's native form cannot carry a file and a founder deck
// has to arrive as one.
var FORM_API = (typeof BWC_API !== 'undefined' && BWC_API) || 'https://surfer-bot.fly.dev';
function openModal(id){var m=document.getElementById(id); if(!m)return;
 m.classList.add('open'); document.body.style.overflow='hidden';
 var f=m.querySelector('input,select,textarea'); if(f)setTimeout(function(){f.focus();},80);}
function closeModal(m){if(!m)return; m.classList.remove('open'); document.body.style.overflow='';}
document.addEventListener('click',function(e){
 var open=e.target.closest('[data-form]');
 if(open){e.preventDefault(); openModal(open.dataset.form==='lp'?'m-lp':'m-pitch'); return;}
 if(e.target.closest('[data-close]')){closeModal(e.target.closest('.modal')); return;}
 if(e.target.classList && e.target.classList.contains('modal')) closeModal(e.target);
});
document.addEventListener('keydown',function(e){
 if(e.key==='Escape'){var o=document.querySelector('.modal.open'); if(o)closeModal(o);}});
// file picker feedback
var dk=document.getElementById('p-deck');
if(dk)dk.addEventListener('change',function(){
 var d=document.getElementById('p-drop'), t=document.getElementById('p-dropt');
 if(dk.files && dk.files[0]){var f=dk.files[0];
  t.textContent=f.name+'  ('+Math.max(1,Math.round(f.size/1024))+' KB)';
  d.classList.add('has');}
 else{t.textContent='Choose a file or drop it here'; d.classList.remove('has');}});
['dragover','dragleave','drop'].forEach(function(ev){
 var d=document.getElementById('p-drop'); if(!d)return;
 d.addEventListener(ev,function(e){e.preventDefault();
  if(ev==='dragover')d.classList.add('over'); else d.classList.remove('over');
  if(ev==='drop' && e.dataTransfer.files.length && dk){
   dk.files=e.dataTransfer.files; dk.dispatchEvent(new Event('change'));}});});
function wire(formId,outId,path){
 var f=document.getElementById(formId); if(!f)return;
 f.addEventListener('submit',function(e){
  e.preventDefault();
  var out=document.getElementById(outId), btn=f.querySelector('button[type=submit]');
  var fd=new FormData(f);
  // validate here so the visitor gets a sentence, not a browser tooltip
  var req=f.querySelectorAll('[required]'), bad=null;
  req.forEach(function(el){ if(!bad && !String(el.value||'').trim()) bad=el; });
  var em=f.querySelector('input[type=email]');
  if(!bad && em && String(em.value).indexOf('@')<0) bad=em;
  if(bad){out.className='fmsg err';
   out.textContent='Please complete the highlighted field — we need a name and a working email address to reply.';
   bad.focus(); return;}
  btn.disabled=true; var label=btn.textContent; btn.textContent='SENDING…';
  out.className='fmsg'; out.textContent='';
  fetch(FORM_API+path,{method:'POST',body:fd})
   .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j};});})
   .then(function(res){
     if(res.ok && res.j.ok!==false){out.className='fmsg ok';
       out.textContent=res.j.message||'Thank you — that is with us.'; f.reset();
       var t=document.getElementById('p-dropt');
       if(t){t.textContent='Choose a file or drop it here';
             document.getElementById('p-drop').classList.remove('has');}}
     else{out.className='fmsg err';
       out.textContent=(res.j && (res.j.detail||res.j.message)) ||
         'That did not go through. Please email surferbot@breakingwavecap.com directly.';}})
   .catch(function(){out.className='fmsg err';
     out.textContent='We could not reach the server. Please email surferbot@breakingwavecap.com directly.';})
   .then(function(){btn.disabled=false; btn.textContent=label;});
 });
}
wire('f-lp','lp-msgout','/forms/lp');
wire('f-pitch','p-msgout','/forms/pitch');

// ── homepage router ────────────────────────────────────────────────────
// Shopify only renders page.<suffix> templates when a matching Page exists in
// admin, so on a fresh install every off-home link 404s. The homepage carries
// all panels and switches them here: deep links (/#team) and browser
// back/forward both work, and no admin setup is required.
(function(){
  var panels=document.querySelectorAll('#panels .panel');
  if(!panels.length) return;                       // a standalone page template
  function keyFromHash(){
    var h=(location.hash||'').replace(/^#\/?/,'').trim();
    return (h && document.getElementById('p-'+h)) ? h : 'index';
  }
  function paint(k,push){
    panels.forEach(function(p){p.hidden = (p.id!=='p-'+k);});
    document.querySelectorAll('nav a.t').forEach(function(a){
      a.classList.toggle('on', a.dataset.go===k);});
    var el=document.getElementById('p-'+k);
    if(el){el.style.animation='none'; void el.offsetWidth; el.style.animation='';}
    if(push){var target = (k==='index') ? '#/' : '#'+k;
      if(location.hash!==target) history.pushState(null,'',target);}
    try{window.scrollTo(0,0);}catch(e){}
    if(typeof arm==='function') arm(el||document);
    if(typeof armBG==='function') armBG(el||document);
    if(typeof onScroll==='function') onScroll();
  }
  document.addEventListener('click',function(e){
    var a=e.target.closest('[data-go]');
    if(!a) return;
    var k=a.dataset.go;
    if(!document.getElementById('p-'+k)) return;   // let a real URL through
    e.preventDefault();
    if(a.id==='surfcta' && typeof surf==='function'){surf(function(){paint(k,true);});}
    else paint(k,true);
  });
  addEventListener('popstate',function(){paint(keyFromHash(),false);});
  addEventListener('hashchange',function(){paint(keyFromHash(),false);});
  paint(keyFromHash(),false);
})();
document.querySelector('#surfcta')?.addEventListener('click',e=>{e.preventDefault();const h=e.currentTarget.getAttribute('href');surf(()=>{location.href=h;});});